import { createApp } from 'vue';
import DateOfBirthInput from '../../common/component/DateOfBirthInput.vue';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('date-of-birth-date-picker');
  if (!el) return;

  const allowEmpty = el.dataset.allowEmpty === 'false' ? false : true;

  // 既存のpropsDataがある場合はマージする
  const propsDataEl = document.getElementById('profile-props-data');
  const baseProps = propsDataEl ? JSON.parse(propsDataEl.dataset.propsData) : {};

  const finalProps = {
    ...baseProps,
    allowEmpty: allowEmpty
  };

  const app = createApp(DateOfBirthInput, finalProps);
  app.mount('#date-of-birth-date-picker');
});
